import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";

import { signinReducer } from "./reducer/signin";
import { createReducer } from "./reducer/create";
import { verifyReducer } from "./reducer/verifiedAcc";
import { emailvReducer } from "./reducer/emailverified";
import { restReducer } from "./reducer/resetlogin";
import { resetlReducer } from "./reducer/resetlink";
import { getconReducer } from "./reducer/getconst";
import { dashuserReducer } from "./reducer/dashboarduser";
import { uploadReducer } from "./reducer/uploadpic";
import { checkReducer } from "./reducer/checkemployee";
import { listReducer } from "./reducer/listemployee";
import { addsalaryReducer } from "./reducer/addSalaries";
import { acceptemployeeReducer } from "./reducer/acceptemployInvite";
import { checkemployeecodeReducer } from "./reducer/checkemploycode";
import { clockinReducer } from "./reducer/clockIn";
import { clockoutReducer } from "./reducer/clockOut";
import { getpendingReducer } from "./reducer/getpendingInvite";
import { inviteemployeeReducer } from "./reducer/inviteemploy";
import { listattendanceReducer } from "./reducer/listAttendance";
import { listsalaryReducer } from "./reducer/listsalaries";
const rootReducer = combineReducers({
    signin: signinReducer,
    create: createReducer,
    verify: verifyReducer,
    emailv: emailvReducer,
    reset: restReducer,
    resetl: resetlReducer,
    getcon: getconReducer,
    dashuser: dashuserReducer,
    upload: uploadReducer,
    check: checkReducer,
    list: listReducer,
    accept: acceptemployeeReducer,
    addsalary:addsalaryReducer,
    checkemployeecode:checkemployeecodeReducer,
    clockin:clockinReducer,
    clockout:clockoutReducer,
    getpending:getpendingReducer,
    invitemployee: inviteemployeeReducer,
    listattendance:listattendanceReducer,
    listsalary:listsalaryReducer,
});

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE_ || compose;

const store = createStore(rootReducer, composeEnhancer(applyMiddleware(thunk)));

export default store;